/**
 * Singleton TanStack Query client (spec 0006 §5.5).
 *
 * Tuned for an admin SPA where:
 *
 * - Operators leave tabs open all day; ``refetchOnWindowFocus`` would
 *   produce a refetch storm of dozens of queries every time someone
 *   tabs back to the window.
 * - 401 is already handled globally by the axios interceptor in
 *   ``api.ts``; retrying a 401 only delays the redirect to /login.
 * - Datasets are small (dozens-to-low-hundreds of rows). A short
 *   ``staleTime`` is fine — invalidations on mutations give us
 *   freshness without a polling baseline.
 */
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
